var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOscuro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 28,
    viewBox: "0 0 154 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2344 6.9834L24.1826 7.07227H24.2354V21.04H24.1719L12.1172 28L0.0625 21.04H0V7.07227H0.0517578L0 6.9834L12.0967 0L12.1172 0.0361328L12.1387 0L24.2344 6.9834ZM3.14844 8.80176V19.1855L12.1162 24.3643L21.0859 19.1855V8.80176L13.6924 4.53223V16.0459H10.5439V4.53125L3.14844 8.80176ZM17.875 8.05078V19.7559H17.8662L17.8838 19.7871L12.1172 23.1172L12.1123 23.1094L12.1084 23.1172L6.3418 19.7881L9.3916 17.9131L12.1113 19.4834L14.7441 17.9639V6.35938L17.875 8.05078Z",
    fill: "url(#paint0_linear_333_107)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.824 11.168C151.072 11.168 152.062 11.546 152.794 12.302C153.538 13.058 153.91 14.108 153.91 15.452V21.32H150.85V15.866C150.85 15.218 150.676 14.72 150.328 14.372C149.992 14.012 149.524 13.832 148.924 13.832C148.324 13.832 147.85 14.012 147.502 14.372C147.166 14.72 146.998 15.218 146.998 15.866V21.32H143.938V15.866C143.938 15.218 143.764 14.72 143.416 14.372C143.08 14.012 142.612 13.832 142.012 13.832C141.412 13.832 140.938 14.012 140.59 14.372C140.254 14.72 140.086 15.218 140.086 15.866V21.32H137.008V11.276H140.086V12.536C140.398 12.116 140.806 11.786 141.31 11.546C141.814 11.294 142.384 11.168 143.02 11.168C143.776 11.168 144.448 11.33 145.036 11.654C145.636 11.978 146.104 12.44 146.44 13.04C146.788 12.488 147.262 12.038 147.862 11.69C148.462 11.342 149.116 11.168 149.824 11.168Z",
    fill: "url(#paint1_linear_333_107)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.384 16.1358C135.384 16.4238 135.366 16.7238 135.33 17.0358H128.364C128.412 17.6598 128.61 18.1398 128.958 18.4758C129.318 18.7998 129.756 18.9618 130.272 18.9618C131.04 18.9618 131.574 18.6378 131.874 17.9898H135.15C134.982 18.6498 134.676 19.2438 134.232 19.7718C133.8 20.2998 133.254 20.7138 132.594 21.0138C131.934 21.3138 131.196 21.4638 130.38 21.4638C129.396 21.4638 128.52 21.2538 127.752 20.8338C126.984 20.4138 126.384 19.8138 125.952 19.0338C125.52 18.2538 125.304 17.3418 125.304 16.2978C125.304 15.2538 125.514 14.3418 125.934 13.5618C126.366 12.7818 126.966 12.1818 127.734 11.7618C128.502 11.3418 129.384 11.1318 130.38 11.1318C131.352 11.1318 132.216 11.3358 132.972 11.7438C133.728 12.1518 134.316 12.7338 134.736 13.4898C135.168 14.2458 135.384 15.1278 135.384 16.1358ZM132.234 15.3258C132.234 14.7978 132.054 14.3778 131.694 14.0658C131.334 13.7538 130.884 13.5978 130.344 13.5978C129.828 13.5978 129.39 13.7478 129.03 14.0478C128.682 14.3478 128.466 14.7738 128.382 15.3258H132.234Z",
    fill: "url(#paint2_linear_333_107)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.201 18.7096V21.3196H122.635C121.519 21.3196 120.649 21.0496 120.025 20.5096C119.401 19.9576 119.089 19.0636 119.089 17.8276V13.8316H117.865V11.2756H119.089V8.82764H122.167V11.2756H124.183V13.8316H122.167V17.8636C122.167 18.1636 122.239 18.3796 122.383 18.5116C122.527 18.6436 122.767 18.7096 123.103 18.7096H124.201Z",
    fill: "url(#paint3_linear_333_107)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.652 21.4638C111.776 21.4638 110.996 21.3138 110.312 21.0138C109.628 20.7138 109.088 20.3058 108.692 19.7898C108.296 19.2618 108.074 18.6738 108.026 18.0258H111.068C111.104 18.3738 111.266 18.6558 111.554 18.8718C111.842 19.0878 112.196 19.1958 112.616 19.1958C113 19.1958 113.294 19.1238 113.498 18.9798C113.714 18.8238 113.822 18.6258 113.822 18.3858C113.822 18.0978 113.672 17.8878 113.372 17.7558C113.072 17.6118 112.586 17.4558 111.914 17.2878C111.194 17.1198 110.594 16.9458 110.114 16.7658C109.634 16.5738 109.22 16.2798 108.872 15.8838C108.524 15.4758 108.35 14.9298 108.35 14.2458C108.35 13.6698 108.506 13.1478 108.818 12.6798C109.142 12.1998 109.61 11.8218 110.222 11.5458C110.846 11.2698 111.584 11.1318 112.436 11.1318C113.696 11.1318 114.686 11.4438 115.406 12.0678C116.138 12.6918 116.558 13.5198 116.666 14.5518H113.822C113.774 14.2038 113.618 13.9278 113.354 13.7238C113.102 13.5198 112.766 13.4178 112.346 13.4178C111.986 13.4178 111.71 13.4898 111.518 13.6338C111.326 13.7658 111.23 13.9518 111.23 14.1918C111.23 14.4798 111.38 14.6958 111.68 14.8398C111.992 14.9838 112.472 15.1278 113.12 15.2718C113.864 15.4638 114.47 15.6558 114.938 15.8478C115.406 16.0278 115.814 16.3278 116.162 16.7478C116.522 17.1558 116.708 17.7078 116.72 18.4038C116.72 18.9918 116.552 19.5198 116.216 19.9878C115.892 20.4438 115.418 20.8038 114.794 21.0678C114.182 21.3318 113.468 21.4638 112.652 21.4638Z",
    fill: "url(#paint4_linear_333_107)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.453 11.2759L101.153 26.0899H97.8411L100.145 20.9779L96.0591 11.2759H99.4971L101.819 17.5579L104.123 11.2759H107.453Z",
    fill: "url(#paint5_linear_333_107)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6908 21.4459C89.7668 21.4459 88.9388 21.2959 88.2068 20.9959C87.4748 20.6959 86.8868 20.2519 86.4428 19.6639C86.0108 19.0759 85.7828 18.3679 85.7588 17.5399H89.0348C89.0828 18.0079 89.2448 18.3679 89.5208 18.6199C89.7968 18.8599 90.1568 18.9799 90.6008 18.9799C91.0568 18.9799 91.4168 18.8779 91.6808 18.6739C91.9448 18.4579 92.0768 18.1639 92.0768 17.7919C92.0768 17.4799 91.9688 17.2219 91.7528 17.0179C91.5488 16.8139 91.2908 16.6459 90.9788 16.5139C90.6788 16.3819 90.2468 16.2319 89.6828 16.0639C88.8668 15.8119 88.2008 15.5599 87.6848 15.3079C87.1688 15.0559 86.7248 14.6839 86.3528 14.1919C85.9808 13.6999 85.7948 13.0579 85.7948 12.2659C85.7948 11.0899 86.2208 10.1719 87.0728 9.51191C87.9248 8.83991 89.0348 8.50391 90.4028 8.50391C91.7948 8.50391 92.9168 8.83991 93.7688 9.51191C94.6208 10.1719 95.0768 11.0959 95.1368 12.2839H91.8068C91.7828 11.8759 91.6328 11.5579 91.3568 11.3299C91.0808 11.0899 90.7268 10.9699 90.2948 10.9699C89.9228 10.9699 89.6228 11.0719 89.3948 11.2759C89.1668 11.4679 89.0528 11.7499 89.0528 12.1219C89.0528 12.5299 89.2448 12.8479 89.6288 13.0759C90.0128 13.3039 90.6128 13.5499 91.4288 13.8139C92.2448 14.0899 92.9048 14.3539 93.4088 14.6059C93.9248 14.8579 94.3688 15.2239 94.7408 15.7039C95.1128 16.1839 95.2988 16.8019 95.2988 17.5579C95.2988 18.2779 95.1128 18.9319 94.7408 19.5199C94.3808 20.1079 93.8528 20.5759 93.1568 20.9239C92.4608 21.2719 91.6388 21.4459 90.6908 21.4459Z",
    fill: "url(#paint6_linear_333_107)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4154 21.4638C74.4314 21.4638 73.5434 21.2538 72.7514 20.8338C71.9714 20.4138 71.3534 19.8138 70.8974 19.0338C70.4534 18.2538 70.2314 17.3418 70.2314 16.2978C70.2314 15.2658 70.4594 14.3598 70.9154 13.5798C71.3714 12.7878 71.9954 12.1818 72.7874 11.7618C73.5794 11.3418 74.4674 11.1318 75.4514 11.1318C76.4354 11.1318 77.3234 11.3418 78.1154 11.7618C78.9074 12.1818 79.5314 12.7878 79.9874 13.5798C80.4434 14.3598 80.6714 15.2658 80.6714 16.2978C80.6714 17.3298 80.4374 18.2418 79.9694 19.0338C79.5134 19.8138 78.8834 20.4138 78.0794 20.8338C77.2874 21.2538 76.3994 21.4638 75.4154 21.4638ZM75.4154 18.7998C76.0034 18.7998 76.5014 18.5838 76.9094 18.1518C77.3294 17.7198 77.5394 17.1018 77.5394 16.2978C77.5394 15.4938 77.3354 14.8758 76.9274 14.4438C76.5314 14.0118 76.0394 13.7958 75.4514 13.7958C74.8514 13.7958 74.3534 14.0118 73.9574 14.4438C73.5614 14.8638 73.3634 15.4818 73.3634 16.2978C73.3634 17.1018 73.5554 17.7198 73.9394 18.1518C74.3354 18.5838 74.8274 18.7998 75.4154 18.7998Z",
    fill: "url(#paint7_linear_333_107)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.705 12.698C61.993 12.23 62.407 11.852 62.947 11.564C63.487 11.276 64.105 11.132 64.801 11.132C65.629 11.132 66.379 11.342 67.051 11.762C67.723 12.182 68.251 12.782 68.635 13.562C69.031 14.342 69.229 15.248 69.229 16.28C69.229 17.312 69.031 18.224 68.635 19.016C68.251 19.796 67.723 20.402 67.051 20.834C66.379 21.254 65.629 21.464 64.801 21.464C64.093 21.464 63.475 21.326 62.947 21.05C62.419 20.762 62.005 20.384 61.705 19.916V21.32H58.627V8H61.705V12.698ZM66.097 16.28C66.097 15.512 65.881 14.912 65.449 14.48C65.029 14.036 64.507 13.814 63.883 13.814C63.271 13.814 62.749 14.036 62.317 14.48C61.897 14.924 61.687 15.53 61.687 16.298C61.687 17.066 61.897 17.672 62.317 18.116C62.749 18.56 63.271 18.782 63.883 18.782C64.495 18.782 65.017 18.56 65.449 18.116C65.881 17.66 66.097 17.048 66.097 16.28Z",
    fill: "url(#paint8_linear_333_107)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0029 16.1358C57.0029 16.4238 56.9849 16.7238 56.9489 17.0358H49.9829C50.0309 17.6598 50.2289 18.1398 50.5769 18.4758C50.9369 18.7998 51.3749 18.9618 51.8909 18.9618C52.6589 18.9618 53.1929 18.6378 53.4929 17.9898H56.7689C56.6009 18.6498 56.2949 19.2438 55.8509 19.7718C55.4189 20.2998 54.8729 20.7138 54.2129 21.0138C53.5529 21.3138 52.8149 21.4638 51.9989 21.4638C51.0149 21.4638 50.1389 21.2538 49.3709 20.8338C48.6029 20.4138 48.0029 19.8138 47.5709 19.0338C47.1389 18.2538 46.9229 17.3418 46.9229 16.2978C46.9229 15.2538 47.1329 14.3418 47.5529 13.5618C47.9849 12.7818 48.5849 12.1818 49.3529 11.7618C50.1209 11.3418 51.0029 11.1318 51.9989 11.1318C52.9709 11.1318 53.8349 11.3358 54.5909 11.7438C55.3469 12.1518 55.9349 12.7338 56.3549 13.4898C56.7869 14.2458 57.0029 15.1278 57.0029 16.1358ZM53.8529 15.3258C53.8529 14.7978 53.6729 14.3778 53.3129 14.0658C52.9529 13.7538 52.5029 13.5978 51.9629 13.5978C51.4469 13.5978 51.0089 13.7478 50.6489 14.0478C50.3009 14.3478 50.0849 14.7738 50.0009 15.3258H53.8529Z",
    fill: "url(#paint9_linear_333_107)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.304 21.3196H42.226L37.078 13.5256V21.3196H34V8.68359H37.078L42.226 16.5136V8.68359H45.304V21.3196Z",
    fill: "url(#paint10_linear_333_107)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_333_107",
    x1: 12.1177,
    y1: 2.01955,
    x2: 12.1177,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_333_107",
    x1: 32.415,
    y1: 14.8198,
    x2: 155.415,
    y2: 14.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_333_107",
    x1: 32.415,
    y1: 14.8198,
    x2: 155.415,
    y2: 14.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_333_107",
    x1: 32.415,
    y1: 14.8198,
    x2: 155.415,
    y2: 14.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_333_107",
    x1: 32.415,
    y1: 14.8198,
    x2: 155.415,
    y2: 14.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_333_107",
    x1: 32.415,
    y1: 14.8198,
    x2: 155.415,
    y2: 14.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_333_107",
    x1: 32.415,
    y1: 14.8198,
    x2: 155.415,
    y2: 14.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_333_107",
    x1: 32.415,
    y1: 14.8198,
    x2: 155.415,
    y2: 14.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_333_107",
    x1: 32.415,
    y1: 14.8198,
    x2: 155.415,
    y2: 14.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_333_107",
    x1: 32.415,
    y1: 14.8198,
    x2: 155.415,
    y2: 14.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_333_107",
    x1: 32.415,
    y1: 14.8198,
    x2: 155.415,
    y2: 14.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOscuro);
export default __webpack_public_path__ + "static/media/logo_oscuro.d626a3fbbedbd775fbd70849201cc37e.svg";
export { ForwardRef as ReactComponent };